import React from "react"
import "./style.css"

import { 
    Button, 
} from "react-bootstrap"

const EMETLSegmentedControlButton = (props) => {
    const { 
        option, 
        perform,
        selected,
    } = props

    return ( 
        <Button 
            variant="outline-info" 
            className={selected ? "selected segmentedControlButton" : "segmentedControlButton"} 
            onClick={perform}
        >
            {option}
        </Button> 
    )
}

export default EMETLSegmentedControlButton